
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxifromchikhalitomumbaiairport() {



    const cardData =
    {
        keyword: 'Taxi from Chikhali to Mumbai Airport',
        heading: 'Platinum24 Cabs: Taxi from Chikhali to Mumbai Airport',
        headingDescription: ' Platinum24 Cabs offers reliable Taxi from Chikhali to Mumbai Airport, ensuring timely and comfortable transfers for business travelers, families, and frequent flyers. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides a smooth ride along the Pune–Mumbai expressway with spacious seating and air-conditioned comfort. With professional chauffeurs, punctual pickups, and transparent fares, we make your airport journey stress-free and dependable. Whether it’s an early morning flight, late-night pickup, or same-day return, Platinum24 Cabs guarantees 24/7 availability and hassle-free travel from Chikhali to Mumbai Airport.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Tourists enjoy ferry rides from here to Elephanta Caves. The monument is beautifully lit up in the evenings, attracting photographers. Surrounded by luxury hotels and street vendors, it is Mumbai’s proud welcoming arch."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. The promenade is popular for evening walks, sunsets, and sea views. At night, the streetlights resemble a necklace, creating a magical sight. Couples, families, and fitness enthusiasts throng the seafront. Street food like bhel puri and pav bhaji add to the charm. Marine Drive is Mumbai’s iconic coastal stretch."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, CSMT is a stunning example of Victorian Gothic architecture. Built in 1887, the railway station blends Indian and European design. Its grand domes, turrets, and stained glass windows make it a masterpiece. It is one of India’s busiest stations and a cultural landmark. At night, the illuminated façade is mesmerizing. CSMT is Mumbai’s architectural and historic pride."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these 5th–6th century rock-cut caves are dedicated to Lord Shiva. The highlight is the massive three-headed Trimurti sculpture. Ferries from Gateway of India take visitors across the Arabian Sea to the caves. Surrounded by lush greenery and monkeys, the site combines nature and heritage. A UNESCO World Heritage Site, it attracts global tourists. Elephanta Caves are Mumbai’s spiritual and cultural treasure."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, located on a small islet in the Arabian Sea, is one of Mumbai’s most visited religious sites. Built in Indo-Islamic architecture, it houses the tomb of Saint Pir Haji Ali Shah Bukhari. The walkway leading to the dargah gets submerged during high tide, adding to its mystique. Devotees of all faiths visit to seek blessings. Evening qawwalis create a soulful ambiance. Haji Ali is Mumbai’s symbol of faith and unity."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered temples dedicated to Lord Ganesha. The temple’s golden dome and beautifully adorned idol attract thousands of devotees daily. Bollywood celebrities and politicians are frequent visitors. Tuesdays and Ganesh Chaturthi see massive footfalls. It is believed prayers here bring prosperity and success. Siddhivinayak is Mumbai’s divine heart of devotion."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside destination, buzzing with street food stalls and crowds. Tourists savor pav bhaji, bhel puri, and kulfi while enjoying the sea breeze. Bollywood celebrities often reside near Juhu, adding glamour. Evenings and sunsets make it vibrant and photogenic. Families and couples find it relaxing. Juhu Beach is Mumbai’s lively leisure hub."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is a shopper’s paradise, famous for street stalls, boutiques, and cafes. Visitors buy clothes, jewelry, handicrafts, and antiques at bargain prices. Popular cafes like Leopold and Mondegar add to its charm. The market reflects Mumbai’s cosmopolitan vibe. Tourists and locals flock here for retail therapy. Colaba Causeway is Mumbai’s colorful shopping street."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Mumbai’s Film City is the beating heart of Bollywood. Spread over 500 acres, it has studios, sets, and shooting locations. Visitors can take guided tours to see film sets and experience the glamour of cinema. It is a dream destination for movie buffs. Many famous Bollywood scenes were shot here. Film City is Mumbai’s reel-to-real entertainment hub."
  },
  {
    "title": "Chowpatty Beach & Girgaon",
    "description": "Chowpatty Beach in Girgaon is famous for Ganesh Visarjan celebrations and Mumbai’s street food culture. The beach comes alive in the evenings with food stalls serving sev puri, pani puri, and kulfi falooda. Festivals and fairs add to its lively atmosphere. Families enjoy leisure walks and sea views here. Sunsets are especially magical. Chowpatty is Mumbai’s cultural and culinary hotspot."
  }
],


        "services": [
    {
      "name": "Chikhali to Mumbai Airport Taxi",
      "description": "Reliable and comfortable taxi service from Chikhali to Mumbai Airport, ensuring timely pickups and hassle-free transfers. Our professional drivers and clean vehicles make your journey smooth and stress-free."
    },
    {
      "name": "Taxi Service Chikhali to Mumbai Airport",
      "description": "Affordable and efficient taxi service for travel between Chikhali and Mumbai Airport. We provide 24x7 availability with experienced drivers to cater to your airport transfer needs."
    },
    {
      "name": "Mumbai Airport Pickup from Chikhali",
      "description": "Book your Mumbai Airport pickup from Chikhali with ease. Our drivers track your flight and ensure prompt arrivals to pick you up, providing a seamless start to your journey."
    },
    {
      "name": "Chikhali to Mumbai Airport Cab Booking",
      "description": "Easy and quick cab booking from Chikhali to Mumbai Airport with instant confirmation. Choose from a variety of vehicle options to suit your budget and comfort."
    },
    {
      "name": "Affordable Taxi Chikhali to Mumbai Airport",
      "description": "Get the best rates for taxi service from Chikhali to Mumbai Airport without compromising on quality and comfort. Transparent pricing and no hidden charges."
    },
    {
      "name": "Chikhali to Mumbai Airport Taxi Fare",
      "description": "Competitive and upfront taxi fare from Chikhali to Mumbai Airport. Know your trip cost in advance to plan your travel budget better."
    },
    {
      "name": "Taxi with Driver Chikhali to Mumbai Airport",
      "description": "Professional drivers familiar with the route from Chikhali to Mumbai Airport ensuring a safe and timely transfer experience."
    },
    {
      "name": "Chikhali to Mumbai Airport Taxi Deals",
      "description": "Exclusive deals and discounts on taxi services from Chikhali to Mumbai Airport for frequent travelers and corporate clients."
    },
    {
      "name": "Chikhali to Mumbai Airport Airport Transfer",
      "description": "Specialized airport transfer service designed to provide smooth and timely transportation from Chikhali to Mumbai Airport."
    },
    {
      "name": "Chikhali to Mumbai Airport Taxi Service 24x7",
      "description": "Round-the-clock taxi service from Chikhali to Mumbai Airport, available any time of day or night to suit your flight schedule."
    },
    {
      "name": "Mumbai Airport Drop from Chikhali Taxi",
      "description": "Reliable drop service from Chikhali to Mumbai Airport with punctual pickups to ensure you reach the airport well before your flight."
    },
    {
      "name": "Mumbai Airport Taxi Booking from Chikhali",
      "description": "Book your Mumbai Airport taxi from Chikhali with our simple online system or via phone, with quick confirmations and flexible payment options."
    },
    {
      "name": "Chikhali to Mumbai Airport One Way Taxi",
      "description": "Convenient one-way taxi services from Chikhali to Mumbai Airport, perfect for travelers needing direct airport transfers without return trips."
    },
    {
      "name": "Chikhali to Mumbai Airport Private Cab",
      "description": "Private cab options for comfortable and exclusive travel from Chikhali to Mumbai Airport, ensuring privacy and personalized service."
    },
    {
      "name": "Chikhali to Mumbai Airport Taxi Packages",
      "description": "Customized taxi packages for regular travelers or groups from Chikhali to Mumbai Airport, offering cost savings and flexible booking."
    }
  ],
  "tableData": [
    ["Chikhali to Mumbai Airport Taxi", "Taxi Service Chikhali to Mumbai Airport"],
    ["Mumbai Airport Pickup from Chikhali", "Chikhali to Mumbai Airport Cab Booking"],
    ["Affordable Taxi Chikhali to Mumbai Airport", "Chikhali to Mumbai Airport Taxi Fare"],
    ["Taxi with Driver Chikhali to Mumbai Airport", "Chikhali to Mumbai Airport Taxi Deals"],
    ["Chikhali to Mumbai Airport Airport Transfer", "Chikhali to Mumbai Airport Taxi Service 24x7"],
    ["Mumbai Airport Drop from Chikhali Taxi", "Mumbai Airport Taxi Booking from Chikhali"],
    ["Chikhali to Mumbai Airport One Way Taxi", "Chikhali to Mumbai Airport Private Cab"],
    ["Chikhali to Mumbai Airport Taxi Packages", "—"]
  ],


     "whychoose": [
    {
      "WhyChooseheading": "Reliable Taxi Service from Chikhali to Mumbai Airport",
      "WhyChoosedescription": "Platinum24 Cabs offers punctual and comfortable taxi rides from Chikhali to Mumbai Airport for a stress-free journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Airport Route Expertise",
      "WhyChoosedescription": "Our professional drivers know the fastest and safest routes to Mumbai Airport, ensuring timely arrivals."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis equipped for a comfortable airport transfer."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose convenient packages that suit your travel schedule, whether one-way or round trip."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront fares including fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and any travel queries."
    },
    {
      "WhyChooseheading": "Safe and Trustworthy Ride for Airport Transfers",
      "WhyChoosedescription": "Travel with verified drivers committed to your safety and timely service."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from sedans, SUVs, or larger vehicles based on your luggage and group size."
    }
  ]



























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer taxi services from Chikhali to Mumbai Airport?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable taxi services from Chikhali to Mumbai Airport.',
    },
    {
        question: 'How can I book a taxi from Chikhali to Mumbai Airport with Platinum24 Cabs?',
        answer: 'You can easily book your taxi through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for the Chikhali to Mumbai Airport route?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are drivers experienced for airport transfers like Chikhali to Mumbai Airport?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the best routes to Mumbai Airport.',
    },
    {
        question: 'Can I book a one-way taxi from Chikhali to Mumbai Airport?',
        answer: 'Absolutely! We offer one-way taxi services for airport transfers from Chikhali to Mumbai Airport.',
    },
    {
        question: 'What is included in the fare for the Chikhali to Mumbai Airport taxi service?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time or extra stops.',
    },
    {
        question: 'Can I customize pickup location within Chikhali for the taxi to Mumbai Airport?',
        answer: 'Yes, you can specify your preferred pickup point within Chikhali.',
    },
    {
        question: 'Are safety measures in place for the taxi service from Chikhali to Mumbai Airport?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety protocols to ensure a safe journey.',
    },
    {
        question: 'Is taxi service from Chikhali to Mumbai Airport available 24x7?',
        answer: 'Yes, Platinum24 Cabs provides 24x7 taxi service for airport transfers including from Chikhali to Mumbai Airport.',
    },
    {
        question: 'Can I book a taxi for return trips from Mumbai Airport to Chikhali?',
        answer: 'Yes, we also offer return trip bookings for your convenience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Patil',
        feedback: 'The taxi from Chikhali to Mumbai Airport was punctual and comfortable. Great service by Platinum24 Cabs!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Smooth and hassle-free airport transfer from Chikhali to Mumbai Airport. Highly recommended.',
        rating: 5,
    },
];

































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const chikhaliMumbaiAirportTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable taxi service from Chikhali to Mumbai Airport with options for airport pickup, drop, private cabs, one-way taxi, and 24x7 availability.",
  "areaServed": {
    "@type": "Place",
    "name": "Chikhali"
  },
  "serviceType": [
    "Chikhali to Mumbai Airport Taxi",
    "Taxi Service Chikhali to Mumbai Airport",
    "Mumbai Airport Pickup from Chikhali",
    "Chikhali to Mumbai Airport Cab Booking",
    "Affordable Taxi Chikhali to Mumbai Airport",
    "Chikhali to Mumbai Airport Taxi Fare",
    "Taxi with Driver Chikhali to Mumbai Airport",
    "Chikhali to Mumbai Airport Taxi Deals",
    "Chikhali to Mumbai Airport Airport Transfer",
    "Chikhali to Mumbai Airport Taxi Service 24x7",
    "Mumbai Airport Drop from Chikhali Taxi",
    "Mumbai Airport Taxi Booking from Chikhali",
    "Chikhali to Mumbai Airport One Way Taxi",
    "Chikhali to Mumbai Airport Private Cab",
    "Chikhali to Mumbai Airport Taxi Packages"
  ],
  "telephone": "+91-XXXXXXXXXX"
};


    return (
        <div>

<Helmet>
  <title>Taxi from Chikhali to Mumbai Airport | Affordable Airport Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable taxi service from Chikhali to Mumbai Airport with options for airport pickup, drop, private cabs, one-way taxi, and 24x7 availability."
  />
  <meta
    name="keywords"
    content="Chikhali to Mumbai Airport Taxi, Taxi Service Chikhali to Mumbai Airport, Mumbai Airport Pickup from Chikhali, Chikhali to Mumbai Airport Cab Booking, Affordable Taxi Chikhali to Mumbai Airport, Chikhali to Mumbai Airport Taxi Fare, Taxi with Driver Chikhali to Mumbai Airport, Chikhali to Mumbai Airport Taxi Deals, Chikhali to Mumbai Airport Airport Transfer, Chikhali to Mumbai Airport Taxi Service 24x7, Mumbai Airport Drop from Chikhali Taxi, Mumbai Airport Taxi Booking from Chikhali, Chikhali to Mumbai Airport One Way Taxi, Chikhali to Mumbai Airport Private Cab, Chikhali to Mumbai Airport Taxi Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(chikhaliMumbaiAirportTaxiSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/77.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxifromchikhalitomumbaiairport;